import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { VendorContext } from "../../../context/vendor/VendorContext";
import { ContactContext } from "../../../context/contact/ContactContext";
import SaveIcon from "@mui/icons-material/Save";
import {
  Hr,
  AlertSpan,
  CssNativeSelect,
  Root,
  ButtonNonDelete,
  ButtonDelete,
} from "./style";
import { ErrorOutline } from "@mui/icons-material";
import { Button, Container, Column, Tittle } from "./style";
import { Alert, FormControl, InputLabel, LinearProgress } from "@mui/material";
import { CssTextField, OptionSelect } from "../Enrollment/style";
import { Dialog } from "@mui/material";
import stylesCss, { OneColumn } from "../Enrollment/naturalPerson/step3/style";
import { H3 } from "../style";
import UpdateDialog from "../Contact/Approvals/secondAccounts/updateDialog";
const optionTypePerson = [
  { value: 1, label: "naturalPerson" },
  { value: 2, label: "legalPerson" },
];
const ManageInformation = () => {
  const { t } = useTranslation();
  const [countryLocal, setCountryLocal] = useState("");
  const [typePersonLocal, setTypePersonLocal] = useState("");
  const [success, setSuccess] = useState(false);
  const [alertUpdateInfo, setAlertUpdateInfo] = useState(false);
  const [alertCountry, setAlertCountry] = useState(false);
  const [alertTypePerson, setAlertTypePerson] = useState(false);
  const [confirmCountry, setConfirmCountry] = useState(false);
  const [confirmTypePerson, setConfirmTypePerson] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [nonNumber, setNonNumber] = useState(false);
  const {
    vendorInformation,
    companyInformation,
    contactPerson,
    logisticsPostalAddress,
    listCountry,
    listProvince,
    listCity,
    listTypeContact,
    getListCountry,
    getListProvince,
    getListCity,
    getVendorInformation,
    sendCompanyInformation,
    sendLogisticsPostalAddress,
    sendContactPersonArr,
    setContactPerson,
    sendVendorInformation,
    sendVendorAXLogisticsAddress,
    sendVendorAXContactPerson,
    sendVendorAXContactPersonRepPurch,
  } = useContext(VendorContext);
  const { currentContact } = useContext(ContactContext);
  const handleCountryInformation = (event) => {
    event.preventDefault();
    setCountryLocal(event.target.value);
    setAlertCountry(true);
  };
  const handleTypePerson = (event) => {
    event.preventDefault();
    setTypePersonLocal(event.target.value);
    setAlertTypePerson(true);
  };
  const handleSubmitTypePerson = async (event) => {
    event.preventDefault();
    setAlertTypePerson(false);
    setConfirmTypePerson(true);
    vendorInformation["type"] = typePersonLocal;
    await Promise.all([sendVendorInformation(vendorInformation)]);
  };
  const handleConfirmCountryInformation = async (event, tag) => {
    event.preventDefault();
    setAlertCountry(false);
    setConfirmCountry(true);
    console.log(countryLocal);
    vendorInformation["country"] = countryLocal;
    await Promise.all([sendVendorInformation(vendorInformation)]);
  };
  const handleInformation = (event) => {
    event.preventDefault();
    // if (event.target.name === "ruc") {
    //   vendorInformation[event.target.name] = event.target.value;
    //   sendVendorInformation(vendorInformation);
    // }
    companyInformation[event.target.name] = event.target.value;
    sendCompanyInformation(companyInformation);
  };
  const handleLogisticsAddressInformation = (event) => {
    event.preventDefault();
    logisticsPostalAddress[event.target.name] = event.target.value;
    sendLogisticsPostalAddress(logisticsPostalAddress);
  };
  const handleContactPersonInformation0 = (event, contact) => {
    event.preventDefault();
    for (let i = 0; i < contactPerson.length; i++) {
      if (contactPerson[i]["id"] === contact["id"]) {
        contactPerson[i][event.target.name] = event.target.value;
        setContactPerson(contactPerson);
      }
    }
  };
  const handleCloseCountry = () => {
    setAlertCountry(false);
  };
  const handleCloseTypePerson = () => {
    setAlertTypePerson(false);
  };
  const submitForm = async (e) => {
    e.preventDefault();
    console.log("guardar infor");
    setAlertUpdateInfo(true);
    const data = logisticsPostalAddress;
    data["guiD_PRIMARY"] = vendorInformation.guiD_PRIMARY_CONTACT;
    data["accounT_NUM"] = vendorInformation.ruc;
    data["country"] = vendorInformation.country;
    data["company"] = vendorInformation.company;
    const resp = await sendVendorAXLogisticsAddress(data);
    console.log(resp);
    if (resp) {
      setSuccess(true);
    } else {
      setSuccess(false);
    }
    setTimeout(() => {
      setAlertUpdateInfo(false);
      setSuccess(false);
    }, 1500);
  };
  const submitFormContactPerson = async (e, type) => {
    e.preventDefault();
    console.log(type);
    let resp = false;
    //Actualiza la información del Contacto Notificaciones de pago y envío de retenciones
    if (type === 0) {
      console.log("guardar info contacto");
      setAlertUpdateInfo(true);
      console.log(contactPerson);
      resp = await sendVendorAXContactPerson(
        contactPerson,
        vendorInformation.ruc,
        vendorInformation.company
      );
      if (resp) {
        await sendContactPersonArr(contactPerson);
      }
    }
    //Actualiza la información del contacto Representante de compras
    if (type === 1) {
      console.log("guardar contacto rep compras");
      setAlertUpdateInfo(true);
      console.log(contactPerson);
      resp = await sendVendorAXContactPersonRepPurch(
        contactPerson,
        vendorInformation.ruc,
        vendorInformation.company
      );
      if (resp) {
        await sendContactPersonArr(contactPerson);
      }
    }
    if (resp) {
      setSuccess(true);
    } else {
      setSuccess(false);
    }
    setTimeout(() => {
      setAlertUpdateInfo(false);
      setSuccess(false);
    }, 1500);
  };

  useEffect(() => {
    const fetchData2 = async () => {
      await Promise.all([getVendorInformation(currentContact)]);
      setLoading(false);
    };
    fetchData2();
  }, []);
  useEffect(() => {
    const fetchData2 = async () => {
      if (vendorInformation.country === "ECU") {
        console.log(vendorInformation.country);
        await Promise.all([getListProvince(vendorInformation.country)]);
        if (logisticsPostalAddress.province !== "") {
          await Promise.all([getListCity(logisticsPostalAddress.province)]);
        }
      }
    };
    fetchData2();
  }, [vendorInformation.country]);
  useEffect(() => {
    const fetchData2 = async () => {
      await Promise.all([getListCountry(vendorInformation.company)]);

      setLoading(false);
    };
    fetchData2();
  }, [vendorInformation.company]);
  useEffect(() => {
    const fetchData2 = async () => {
      if (vendorInformation.country === "ECU") {
        await Promise.all([getListCity(logisticsPostalAddress.province)]);
      }
    };
    fetchData2();
  }, [logisticsPostalAddress.province]);

  if (isLoading) {
    return <LinearProgress color="error" />;
  }
  // if (contactPerson.length > 0) {
  //   for (let i = 0; i < contactPerson.length; i++) {
  //     if (contactPerson[i].email.includes("|")) {
  //       console.log("first");
  //       contactPerson[i]["correos"] = contactPerson[i].email.split("|");
  //       console.log(contactPerson);
  //     }
  //     if (contactPerson[i].email.includes(";")) {
  //       console.log("first");
  //       contactPerson[i]["correos"] = contactPerson[i].email.split(";");
  //       console.log(contactPerson);
  //     }

  //   }
  // }
  return (
    <>
      {alertCountry && (
        <Dialog onClose={handleCloseCountry} open={alertCountry}>
          <br />
          <Container>
            <H3>{t("alertChangeInformation")}</H3>
            <ButtonNonDelete
              style={{ width: "100%" }}
              onClick={handleCloseCountry}
            >
              {t("no")}
            </ButtonNonDelete>
            <ButtonDelete
              style={{ width: "100%" }}
              onClick={handleConfirmCountryInformation}
            >
              {t("yes")}
            </ButtonDelete>
          </Container>
        </Dialog>
      )}
      {alertTypePerson && (
        <Dialog onClose={handleCloseTypePerson} open={alertTypePerson}>
          <br />
          <Container>
            <H3>{t("alertChangeInformation")}</H3>
            <ButtonNonDelete
              style={{ width: "100%" }}
              onClick={handleCloseTypePerson}
            >
              {t("no")}
            </ButtonNonDelete>
            <ButtonDelete
              style={{ width: "100%" }}
              onClick={handleSubmitTypePerson}
            >
              {t("yes")}
            </ButtonDelete>
          </Container>
        </Dialog>
      )}
      {alertUpdateInfo && (
        <UpdateDialog
          success={success}
          showDialogUpdate={alertUpdateInfo}
          setShowDialogUpdate={setAlertUpdateInfo}
        />
      )}
      <form onSubmit={submitForm}>
        <Root style={{ padding: "5px" }}>
          <Tittle>{t("companyInformation")}</Tittle>
          <Container>
            <Column>
              <FormControl required fullWidth>
                <InputLabel>{t("country")}</InputLabel>
                <CssNativeSelect
                  disabled={confirmCountry || vendorInformation.country !== ""}
                  value={vendorInformation.country}
                  id="country"
                  name="country"
                  onChange={(e) => handleCountryInformation(e)}
                >
                  <OptionSelect></OptionSelect>
                  {listCountry.map((item, index) => (
                    <OptionSelect key={index} value={item.countryRegionId}>
                      {item.shortName}
                    </OptionSelect>
                  ))}
                </CssNativeSelect>
              </FormControl>
            </Column>
            <Column>
              <FormControl required fullWidth>
                <InputLabel>{t("type")}</InputLabel>
                <CssNativeSelect
                  disabled={confirmTypePerson || vendorInformation.type !== ""}
                  value={vendorInformation.type}
                  id="type"
                  name="type"
                  onChange={(e) => handleTypePerson(e)}
                >
                  <OptionSelect></OptionSelect>
                  {optionTypePerson.map((item, index) => (
                    <OptionSelect key={index} value={item.value}>
                      {t(item.label)}
                    </OptionSelect>
                  ))}
                </CssNativeSelect>
              </FormControl>
            </Column>
            <Column>
              {vendorInformation.country === "ECU" ? (
                <CssTextField
                  type={"text"}
                  value={companyInformation.businesS_NAME}
                  required={true}
                  fullWidth
                  disabled
                  label={t("businessName") + " (" + t("sriNotice") + ")"}
                  id="businesS_NAME"
                  name="businesS_NAME"
                  onChange={(e) => handleInformation(e)}
                />
              ) : (
                <CssTextField
                  type={"text"}
                  value={companyInformation.businesS_NAME}
                  required={true}
                  fullWidth
                  disabled
                  label={t("businessName")}
                  id="businesS_NAME"
                  name="businesS_NAME"
                  onChange={(e) => handleInformation(e)}
                />
              )}
            </Column>
            {vendorInformation.country === "ECU" && (
              <Column>
                <CssTextField
                  type={"text"}
                  value={companyInformation.ruc}
                  required={true}
                  fullWidth
                  disabled
                  label={t("ruc") + " (" + t("sriNotice") + ")"}
                  id="ruc"
                  name="ruc"
                  onChange={(e) => handleInformation(e)}
                />
              </Column>
            )}
            <Column>
              <CssTextField
                type={"text"}
                required={true}
                fullWidth
                label={t("foundationYear")}
                value={companyInformation.fundatioN_YEAR}
                name="fundatioN_YEAR"
                id="fundatioN_YEAR"
                onChange={(e) => handleInformation(e)}
              />
            </Column>
            <Column>
              <CssTextField
                type={"text"}
                value={logisticsPostalAddress.address}
                required={true}
                fullWidth
                label={t("address")}
                id="address"
                name="address"
                onChange={(e) => handleLogisticsAddressInformation(e)}
              />
            </Column>
            {vendorInformation.country === "ECU" && (
              <Column>
                <FormControl required fullWidth>
                  <InputLabel>{t("province")}</InputLabel>
                  <CssNativeSelect
                    value={logisticsPostalAddress.province}
                    id="province"
                    name="province"
                    onChange={(e) => handleLogisticsAddressInformation(e)}
                  >
                    <OptionSelect></OptionSelect>
                    {listProvince.map((item) => (
                      <OptionSelect key={item.countyId} value={item.countyId}>
                        {item.name}
                      </OptionSelect>
                    ))}
                  </CssNativeSelect>
                </FormControl>
              </Column>
            )}
            {vendorInformation.country === "ECU" ? (
              <Column>
                <FormControl required fullWidth>
                  <InputLabel>{t("city")}</InputLabel>
                  <CssNativeSelect
                    value={logisticsPostalAddress.city}
                    id="city"
                    name="city"
                    label={t("city") + " *"}
                    onChange={(e) => handleLogisticsAddressInformation(e)}
                  >
                    <OptionSelect></OptionSelect>
                    {listCity.map((item) => (
                      <OptionSelect key={item.name} value={item.name}>
                        {item.description}
                      </OptionSelect>
                    ))}
                  </CssNativeSelect>
                </FormControl>
              </Column>
            ) : (
              <Column>
                <CssTextField
                  type={"text"}
                  value={logisticsPostalAddress.city}
                  required={true}
                  fullWidth
                  label={t("city")}
                  id="city"
                  name="city"
                  onChange={(e) => handleLogisticsAddressInformation(e)}
                />
              </Column>
            )}
            <Column>
              <CssTextField
                type={"text"}
                value={logisticsPostalAddress.postaL_CODE}
                required={true}
                fullWidth
                label={t("postalCode")}
                id="postaL_CODE"
                name="postaL_CODE"
                onChange={(e) => handleLogisticsAddressInformation(e)}
              />
            </Column>
            <Column>
              <CssTextField
                type={"email"}
                value={companyInformation.email}
                required={true}
                fullWidth
                label={t("email")}
                id="email"
                name="email"
                onChange={(e) => handleInformation(e)}
              />
            </Column>
            <Column>
              <CssTextField
                type={"number"}
                value={companyInformation.nuM_EMPLOYEES}
                required={false}
                fullWidth
                inputProps={{ min: 0 }}
                label={t("numEmployee")}
                id="nuM_EMPLOYEES"
                name="nuM_EMPLOYEES"
                onChange={(e) => handleInformation(e)}
              />
            </Column>
            <Column>
              <CssTextField
                type={"text"}
                required={false}
                value={companyInformation.urL_SITE}
                fullWidth
                label={t("webSiteUrl")}
                id="urL_SITE"
                name="urL_SITE"
                onChange={(e) => handleInformation(e)}
              />
            </Column>
          </Container>
          <Container>
            <OneColumn>
              <Button style={{ marginTop: "5px" }} type="submit">
                {t("update")} <SaveIcon />
              </Button>
            </OneColumn>
          </Container>
        </Root>
      </form>
      {contactPerson.length > 0 && (
        <Root>
          {contactPerson.map((item, index) => {
            return (
              <form
                key={index}
                onSubmit={(e) => submitFormContactPerson(e, index)}
              >
                <Tittle>
                  {t("contactPerson") +
                    " " +
                    listTypeContact.filter((x) => x.code === item.type)[0]
                      .description}
                </Tittle>
                <Hr />
                <Container>
                  <Column>
                    <CssTextField
                      type={"text"}
                      value={item.name}
                      required={true}
                      fullWidth
                      label={t("fullName")}
                      id="name"
                      name="name"
                      onChange={(e) => handleContactPersonInformation0(e, item)}
                    />
                  </Column>
                  <Column>
                    <CssTextField
                      type={"text"}
                      value={item.position}
                      required={true}
                      fullWidth
                      label={t("position")}
                      id="position"
                      name="position"
                      onChange={(e) => handleContactPersonInformation0(e, item)}
                    />
                  </Column>
                  <Column>
                    <CssTextField
                      type={"text"}
                      value={item.area}
                      required={true}
                      fullWidth
                      label={t("area")}
                      id="area"
                      name="area"
                      onChange={(e) => handleContactPersonInformation0(e, item)}
                    />
                  </Column>
                  <Column>
                    <CssTextField
                      type={"text"}
                      value={item.phone}
                      required={true}
                      fullWidth
                      label={t("phone")}
                      id="phone"
                      name="phone"
                      onChange={(e) => handleContactPersonInformation0(e, item)}
                    />
                    {nonNumber && item.phone === "" && (
                      <AlertSpan>
                        <ErrorOutline /> {t("incorrectValue")}
                      </AlertSpan>
                    )}
                  </Column>
                  <Alert style={{ width: "100%" }} severity="info">
                    {t("emailInstructions")}
                  </Alert>
                  <OneColumn>
                    <CssTextField
                      type={"text"}
                      value={item.email}
                      required={true}
                      fullWidth
                      label={t("email")}
                      id="email"
                      name="email"
                      onChange={(e) => handleContactPersonInformation0(e, item)}
                    />
                  </OneColumn>
                  {/* {item.correos &&
                    item.correos.map((correo, index) => {
                      return (
                        <Column>
                          <CssTextField
                            type={"text"}
                            value={correo}
                            required={true}
                            fullWidth
                            label={t("email")}
                            id="email"
                            name="email"
                            onChange={(e) =>
                              handleContactPersonInformation0(e, correo)
                            }
                          />
                        </Column>
                      );
                    })} */}
                </Container>
                <Container>
                  <OneColumn>
                    <Button style={{ marginTop: "5px" }} type="submit">
                      {t("update")} <SaveIcon />
                    </Button>
                  </OneColumn>
                </Container>
              </form>
            );
          })}
        </Root>
      )}
    </>
  );
};

export default ManageInformation;
